import React, { useState } from 'react';
import { Plus, Trash2, Users } from 'lucide-react';
import { Button } from '../../ui/Button';
import { Input } from '../../ui/Input';
import { PracticeAttendee, PracticeDraft } from '../../../types/practice';
import { newId } from '../../../utils/practices';
interface PracticeAttendeesProps {
  draft: PracticeDraft;
  onChange: (attendees: PracticeAttendee[]) => void;
  onOpenPicker: () => void;
}
const emptyRecord = {
  firstName: '',
  lastName: '',
  email: ''
};
export function PracticeAttendees({
  draft,
  onChange,
  onOpenPicker
}: PracticeAttendeesProps) {
  const attendees = draft.attendees || [];
  const isOccasional = draft.clientType === 'occasionale';
  const [record, setRecord] = useState(emptyRecord);
  const [recordError, setRecordError] = useState('');
  const addRecord = () => {
    if (!record.firstName.trim() || !record.lastName.trim() || !record.email.trim()) {
      setRecordError('Inserisci nome, cognome ed email personale');
      return;
    }
    if (!/^\S+@\S+\.\S+$/.test(record.email.trim())) {
      setRecordError("Inserisci un'email valida");
      return;
    }
    onChange([...attendees, {
      id: newId('att'),
      firstName: record.firstName.trim(),
      lastName: record.lastName.trim(),
      email: record.email.trim()
    }]);
    setRecord(emptyRecord);
    setRecordError('');
  };
  const remove = (id: string) => onChange(attendees.filter(a => a.id !== id));
  return <div data-id="element-1295" data-mp="1secjtjpeerpc">
      <div className="flex items-center justify-between gap-3 mb-2" data-id="element-1296" data-mp="1nhm44xhi9y4g">
        <p className="text-sm font-medium text-slate-700" data-id="element-1297" data-mp="1ngb0cxo28qdc">
          Partecipanti al corso
          <span className="font-normal text-slate-500" data-id="element-1298" data-mp="1jgkdh51nmue3"> · {attendees.length}</span>
        </p>
        {!isOccasional && <Button variant="flat" color="secondary" size="sm" startContent={<Users className="h-4 w-4" data-id="element-1300" data-mp="38uyypfdgrz4u" />} onClick={onOpenPicker} data-id="element-1299" data-mp="1ejahf6jrfkha">
            {attendees.length > 0 ? 'Modifica partecipanti' : 'Seleziona partecipanti'}
          </Button>}
      </div>

      {isOccasional && <div className="rounded-xl bg-slate-50 p-4 mb-3" data-id="element-1301" data-mp="lxzesvvyd45">
          <div className="grid grid-cols-1 md:grid-cols-[1fr_1fr_1.3fr_auto] gap-3 items-end" data-id="element-1302" data-mp="3iyvsqgy6a7pc">
            <Input label="Nome" value={record.firstName} onChange={e => setRecord({
          ...record,
          firstName: e.target.value
        })} data-id="element-1303" data-mp="3ny051gge8ljw" />
            <Input label="Cognome" value={record.lastName} onChange={e => setRecord({
          ...record,
          lastName: e.target.value
        })} data-id="element-1304" data-mp="fg2owvv74x8d" />
            <Input label="Email personale" type="email" value={record.email} onChange={e => setRecord({
          ...record,
          email: e.target.value
        })} onKeyDown={e => {
          if (e.key === 'Enter') {
            e.preventDefault();
            addRecord();
          }
        }} data-id="element-1305" data-mp="5jr8pushjn8n" />
            <Button startContent={<Plus className="h-4 w-4" data-id="element-1307" data-mp="2nrwn9oochdxq" />} onClick={addRecord} data-id="element-1306" data-mp="2no8uirqq4vk2">
              Aggiungi
            </Button>
          </div>
          {recordError ? <p className="text-xs text-red-600 font-medium mt-2" data-id="element-1308" data-mp="2wqqe0yezva3d">{recordError}</p> : <p className="text-xs text-slate-500 mt-2" data-id="element-1309" data-mp="2rr5eals02xpl">
              Le persone restano salvate solo in questa pratica: l'azienda occasionale
              non è in anagrafica clienti.
            </p>}
        </div>}

      {attendees.length === 0 ? <p className="text-sm text-slate-500" data-id="element-1310" data-mp="2drmceaps8ilq">
          {isOccasional ? 'Nessun partecipante aggiunto.' : 'Nessun partecipante selezionato.'}
        </p> : <ul className="rounded-xl border border-slate-200 divide-y divide-slate-100 max-h-64 overflow-y-auto" data-id="element-1311" data-mp="1lbbkk4lzv0d0">
          {attendees.map(a => <li key={a.id} className="flex items-center gap-3 px-4 py-2" data-id="element-1312" data-mp="1gbgu2264scsh">
              <span className="flex-1 min-w-0" data-id="element-1313" data-mp="1tzh55gr2ze6g">
                <span className="block text-sm font-medium text-slate-800 truncate" data-id="element-1314" data-mp="1u0sa3jw9irz5">
                  {a.firstName} {a.lastName}
                </span>
                <span className="block text-xs text-slate-500 truncate" data-id="element-1315" data-mp="23wvbgnjaiml1">{a.email}</span>
              </span>
              <button type="button" onClick={() => remove(a.id)} aria-label={`Rimuovi ${a.firstName} ${a.lastName}`} className="p-1.5 rounded-lg text-slate-400 hover:text-red-600 hover:bg-red-50 transition-colors" data-id="element-1316" data-mp="28o3orunqqs3h">
                <Trash2 className="h-4 w-4" data-id="element-1317" data-mp="2mnd2mnoh5a4a" />
              </button>
            </li>)}
        </ul>}
    </div>;
}